import { QuotationColor } from './enum';
/** 只区分是涨色还是跌色 通过quotationColor去映射 */
// 明亮模式 涨色
const lightUpColor = {
    [QuotationColor.RED_UP_GREEN_DOWN]: '#FA3C48',
    [QuotationColor.GREEN_UP_RED_DOWN]: '#23BF70',
};
//  明亮模式 跌色
const lightDownColor = {
    [QuotationColor.RED_UP_GREEN_DOWN]: '#23BF70',
    [QuotationColor.GREEN_UP_RED_DOWN]: '#FA3C48',
};
// 明亮模式，
export const lightBrokerSale = {
    [QuotationColor.RED_UP_GREEN_DOWN]: '#F22438',
    [QuotationColor.GREEN_UP_RED_DOWN]: '#01A662',
};
export const lightBrokerSale_2 = {
    [QuotationColor.RED_UP_GREEN_DOWN]: '#01A662',
    [QuotationColor.GREEN_UP_RED_DOWN]: '#F22438',
};
// 暗黑模式 涨色
const darkUpColor = {
    [QuotationColor.RED_UP_GREEN_DOWN]: '#C9243A',
    [QuotationColor.GREEN_UP_RED_DOWN]: '#1aab67',
};
// 暗黑模式 跌色
const darkDownColor = {
    [QuotationColor.RED_UP_GREEN_DOWN]: '#1aab67 ',
    [QuotationColor.GREEN_UP_RED_DOWN]: '#C9243A',
};
// 暗黑模式
export const darkBrokerSale = {
    [QuotationColor.RED_UP_GREEN_DOWN]: '#1CA949',
    [QuotationColor.GREEN_UP_RED_DOWN]: '#F74551',
};
export const darkBrokerSale_2 = {
    [QuotationColor.RED_UP_GREEN_DOWN]: '#F74551',
    [QuotationColor.GREEN_UP_RED_DOWN]: '#1CA949',
};
// 明亮模式
const lightModeColors = quotationColor => {
    return {
        // 折线图颜色 新
        COMMONCOLOR: [
            '#165DFF',
            '#FF9917',
            '#14C9C9',
            '#F6CD00',
            '#974CFF',
            '#9FDB1D',
            '#EB17EB',
            '#23BF70',
            '#FF249D',
            '#6366FF',
            '#F53958',
            '#25A3FF',
        ],
        UP: lightUpColor[quotationColor],
        DOWN: lightDownColor[quotationColor],
        AXISLINE: '#E7E8EF',
        AXISLINE_V2: '#F6F7F9',
        INFO_COLOR: '#2469F2',
        WARN_COLOR: '#FF7925',
        TEXT: '#1E1E29',
        TEXT_V2: '#818799',
        TEXT_COLOR_1: '#1E1E29',
        TEXT_COLOR_2: '#656B80',
        CENTER_TEXT: '#868A8F',
        MARKLINE_TEXT: '#1f2128',
        TOOLTIP_BG: '#FFF',
        TOOLTIP_BG_RADER: 'rgba(255,255,255,0.85)',
        TOOLTIP_TEXT: '#191919',
        TOOLTIP_LINE: '#AAB5BF',
        TOOLTIP_CROSS_LINE: '#CBCDD6',
        TOOLTIP_SHADOW: 'rgba(0,0,0,0.1)',
        NEW_TOOLTIP_SHADOW: 'rgba(124, 138, 160, 0.2)',
        NEW_TREND_TOOLTIP_SHADOW: '0px 0px 1px 0px rgba(0, 0, 0, 0.20), 0px 4px 16px 0px rgba(0, 0, 0, 0.08), 0px 4px 8px 0px rgba(0, 0, 0, 0.05)',
        TOOLTIP_AXISPOINTER_SHADOW: 'rgba(124,138,160, 0.08)',
        BG: '#FFF',
        PIE_BG: '#F6F7F9',
        RANDAR_LINE: '#C5DCFF',
        CROSS_BG: '#EDF1F5',
        SALE_BUG_BG: lightBrokerSale_2[quotationColor],
        SALE_BUG_BG1: lightBrokerSale[quotationColor],
        BONUSLINE: '#7D8B96',
        BAR_BG: '#F5F7F8',
        PIEBGCOLOR: '#f5f7fa',
        LINECOLORONE: '#F58E0F',
        LINECOLORTWO: '#4483FC',
        RADARSPLIT_COLOR: '#EDEFF3',
        RDDARCOLOR: ['#165DFF', '#FF9917'],
        LEGEND_FD: '#191919',
        NODATA: '#f7f9fc',
        SYMBOL_BORDER_COLOR: '#EDEFF3',
        // 热力图图块字体颜色
        HOT_C: '#FFFFFF',
        // 美股添加颜色
        US_AXIS_TEXT: '#FFFFFF',
        US_AXIS_BG: '#8E96AB',
        RISE_OR_FALL: [lightDownColor[quotationColor], lightUpColor[quotationColor], '#165DFF'],
        CHART_TICK: '#656B80',
        FTEN_TOOLTIP: '#1f2128',
        FTEN_LEGEND: '#1f2128',
        FTEN_WHITE_BG: '#FFF',
        FTEN_SPLIT_LINE: 'rgba(237, 239, 245)',
        POINTER_SHADOW: 'rgba(129, 135, 153, 0.07)',
        POINTER_LINE: 'rgba(142, 150, 171, 0.25)',
        TOOLTIP_BDBGC: 'transparent',
        TOOLTIP_LINE_NEW: '#CBCDD6',
        PIE_TOOLTIP_SHADOW: '0 0 1px 0 rgb(255 255 255 / 40%), 0 6px 16px 0 rgb(0 0 0 / 24%), 0 4px 8px 0 rgb(0 0 0 / 15%)',
        BAR_TOOLTIP_LABEL_COLOR: '#919AAB',
    };
};
// 暗黑模式
const darkModeColors = quotationColor => {
    return {
        // 折线图颜色 新
        COMMONCOLOR: [
            '#3D7DFD',
            '#E8A33C',
            '#35C3BE',
            '#E8CE27',
            '#A45CFF',
            '#A9D33F',
            '#E13CDB',
            '#19A664',
            '#E8489A',
            '#7866FF',
            '#D53545',
            '#4BB0ED',
        ],
        UP: darkUpColor[quotationColor],
        DOWN: darkDownColor[quotationColor],
        AXISLINE: 'rgba(149, 151, 164, 0.2)',
        AXISLINE_V2: 'rgba(57, 63, 82, 0.2)',
        INFO_COLOR: '#3578FD',
        WARN_COLOR: '#FF7C29',
        TEXT: '#F0F1F4',
        TEXT_V2: 'rgba(142, 150, 171, 0.9)',
        TEXT_COLOR_1: '#F0F1F4',
        TEXT_COLOR_2: '#D4D5D9',
        CENTER_TEXT: 'rgba(142, 150, 171, 0.9)',
        MARKLINE_TEXT: '#f0f1f4',
        TOOLTIP_BG: '#2F313D',
        TOOLTIP_BG_RADER: 'rgba(58, 60, 74,0.85)',
        TOOLTIP_TEXT: '#E9EAF4',
        TOOLTIP_LINE: '#AAB5BF',
        TOOLTIP_CROSS_LINE: '#41424D',
        TOOLTIP_SHADOW: 'rgba(54, 56, 69, 0.5)',
        NEW_TOOLTIP_SHADOW: 'rgba(0, 0, 0, 0.2)',
        NEW_TREND_TOOLTIP_SHADOW: '0 0 1px 0 rgb(255 255 255 / 40%), 0 6px 16px 0 rgb(0 0 0 / 24%), 0 4px 8px 0 rgb(0 0 0 / 15%)',
        TOOLTIP_AXISPOINTER_SHADOW: 'rgba(124,138,160, 0.08)',
        BG: '#252633',
        PIE_BG: '#2f313d',
        RANDAR_LINE: '#334569',
        CROSS_BG: '#2D2E3F',
        SALE_BUG_BG: darkBrokerSale[quotationColor],
        SALE_BUG_BG1: darkBrokerSale_2[quotationColor],
        BONUSLINE: '#676D71',
        BAR_BG: '#2C2D3D',
        PIEBGCOLOR: '#303142',
        LINECOLORONE: '#F58E0F',
        LINECOLORTWO: '#4483FC',
        RADARSPLIT_COLOR: 'rgba(149, 151, 164, 0.4)',
        RDDARCOLOR: ['#3D7DFD', '#E8A33C'],
        LEGEND_FD: '#E9EAF4',
        NODATA: '#242c3d',
        SYMBOL_BORDER_COLOR: '#424555',
        // 热力图图块字体颜色
        HOT_C: '#FFFFFF',
        // 美股添加颜色
        US_AXIS_TEXT: '#FFFFFF',
        US_AXIS_BG: '#8E96AB',
        RISE_OR_FALL: [darkDownColor[quotationColor], darkUpColor[quotationColor], '#165DFF'],
        CHART_TICK: 'rgba(212, 213, 217, 0.9)',
        FTEN_TOOLTIP: '#f0f1f4',
        FTEN_LEGEND: '#f0f1f4',
        FTEN_WHITE_BG: '#1A1C24',
        FTEN_SPLIT_LINE: 'rgba(57, 63, 82)',
        POINTER_SHADOW: 'rgba(122, 128, 153, 0.07)',
        POINTER_LINE: 'rgba(76, 82, 105, 0.50)',
        TOOLTIP_BDBGC: 'transparent',
        TOOLTIP_LINE_NEW: '#41424D',
        PIE_TOOLTIP_SHADOW: '0 0 1px 0 rgb(255 255 255 / 40%), 0 6px 16px 0 rgb(0 0 0 / 24%), 0 4px 8px 0 rgb(0 0 0 / 15%)',
        BAR_TOOLTIP_LABEL_COLOR: '#575E73',
    };
};
// 获取颜色 themeMode
/**
 * @param themeMode 主题色
 * @param quotationColor 行情色
 */
export function getColors(themeMode, quotationColor) {
    return themeMode === 'light' ? lightModeColors(quotationColor) : darkModeColors(quotationColor);
}
